import { globalFetch } from './globalActions';
import { TECH_MESSAGE_SUCCESS, TECH_MESSAGE_IS_LOADING, TECH_MESSAGE_HAS_ERRORED } from './types';
import { checkLang } from "../helpers";

///////////
// Tech Message Feed //
///////////

export function fetchTechMessage() {
	return globalFetch({
		urlPath: `tech-issue`,
		urlSrc: 1,
		reducerIsLoading: TECH_MESSAGE_IS_LOADING,
		reducerError: TECH_MESSAGE_HAS_ERRORED,
		dispatchSuccess: (itemObj, dispatch) => {
			dispatch(fetchTechMessageSuccess(itemObj));
		}
	});
}

export function fetchTechMessageSuccess(items) {
	let message = {};
	const errorFlag = items?.messageFlag || false;
	
	if(errorFlag) { 
		const lang = checkLang(undefined, true); 
		const data = items && lang ? items[lang] : {};
		if (data && Object.keys(data).length > 0) {
			message = {
				"error": true, "message": {
					copy: data.content,
					buttons: data.buttons,
					title: data.title
				}
			};
		}
	}

	return {
		type: TECH_MESSAGE_SUCCESS,
		payload: message
	};
}